
<section class="w-full">
    <div class="h-100 relative bg-cover bg-no-repeat bg-center flex flex-col justify-center items-center bg-[url('https://api.travelfind.me/v1/images/site/c66224c5-e632-44e7-b486-5b696fa7a08d')]">
        <div class="absolute inset-0 bg-gradient-to-r from-gray-800 via-gray-800/40"></div>
        <div class="w-[90%] mx-auto h-full flex items-start pt-26 justify-between">
            <div class="lg:w-fit z-10">
                <div class="text-left text-white text-6xl tracking-wide font-bold custom_font">
                    <h1>{{ this.view.site?.slogan }}</h1>
                </div>
                <p class="text-md max-w-128 text-white p-2 leading-6">
                    Making your dream to see the world come true is a thrilling
                    and enriching goal. Traveling allows you to experience new
                    cultures, cuisines, landscapes, and ways of life, broadening
                    your perspectives and creating unforgettable memories
                </p>
                <button
                    class="mt-3 rounded font-bold text-primary-100 py-4 px-6 transition bg-primary-500 transition-duration: 500ms hover:bg-primary-100 hover:text-primary-500">
                    Book Your Stay
                </button>
            </div>
        </div>

        @if (view.site && view.site.profile && view.site.profile.sections.searchWidget > 0) {
        <div class="mt-2 w-[90%] rounded-t-lg m-auto z-10">
            <ul class="flex flex-wrap m-auto justify-between -mb-px text-sm p-4 font-medium text-center backdrop-blur-sm bg-white/30 rounded-t-lg w-full max-w-xl"
                id="default-styled-tab" role="tablist">
                <li class="z-30 me-2 focus-within:z-10">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:bg-gray-100 active:bg-gray-200 text-white hover:text-black uppercase transition-all ease-in-out cursor-pointer [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="fights-tab" [class.active]="view.selectedTab === 'flight'" (click)="selectTab('flight')"
                        type="button" role="tab" aria-controls="flights" aria-selected="true">
                        Flights
                    </button>
                </li>
                <li class="me-2">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:text-gray-600 active:bg-gray-200 hover:bg-gray-100 text-white uppercase [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="hotels-tab" [class.active]="view.selectedTab === 'hotel'" (click)="selectTab('hotel')" type="button"
                        role="tab" aria-controls="hotels" aria-selected="view.selectedTab === 'hotel'">
                        Hotels
                    </button>
                </li>
                <li class="me-2">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:text-gray-600 active:bg-gray-200 hover:bg-gray-100 text-white uppercase [&.active]:text-primary-500 [&.active]:bg-primary-100"
                        id="Packages-tab" [class.active]="view.selectedTab === 'Package'" (click)="selectTab('Package')"
                        type="button" role="tab" aria-controls="Packages" aria-selected="view.selectedTab === 'Package'">
                        Packages
                    </button>
                </li>
                <li class="me-2">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white uppercase [&.active]:text-primary-500 [&.active]:bg-primary-100 "
                        id="cars-tab" [class.active]="view.selectedTab === 'car'" (click)="selectTab('car')" type="button"
                        role="tab" aria-controls="cars" aria-selected="view.selectedTab === 'car'">
                        Cars
                    </button>
                </li>
                <li class="me-2">
                    <button
                        class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white uppercase [&.active]:text-primary-500 [&.active]:bg-primary-300"
                        id="transfers-tab" [class.active]="view.selectedTab === 'transfer'" (click)="selectTab('transfer')"
                        type="button" role="tab" aria-controls="transfers" aria-selected="view.selectedTab === 'transfer'">
                        Transfers
                    </button>
                </li>
                <!-- <li class="me-2">
                            <button class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white hover:text-black  uppercase" id="activities-tab" [class.active]="view.selectedTab === 'activities'" (click)="selectTab('activities')" type="button" role="tab" aria-controls="activities" aria-selected="view.selectedTab === 'activities'">Activities</button>
                        </li>
                        <li class="me-2">
                            <button class="inline-block px-5 py-2 rounded-md hover:text-gray-600 hover:bg-gray-100 text-white hover:text-black  uppercase" id="cruises-tab" [class.active]="view.selectedTab === 'cruises'" (click)="selectTab('cruises')" type="button" role="tab" aria-controls="cruises" aria-selected="view.selectedTab === 'cruises'">Cruises</button>
                        </li> -->
            </ul>
            <div id="default-styled-tab-content" class="backdrop-blur-sm bg-white/30 rounded-tr-lg rounded-tl-lg ">
                @if (view.selectedTab === 'flight') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'flight' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'hotel') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'stay' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                    <!-- <stay-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></stay-list> -->
                </div>
                } @if (view.selectedTab === 'Package') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'package' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'car') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'car' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'transfer') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'transfer' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'activity') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'activity' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                } @if (view.selectedTab === 'cruise') {
                <div class="md:rounded-lg">
                    <search-widget [panel]="{ type: 'cruise' }" (tripChange)="tripChanged($event)"
                        (searchChange)="searchChanged($event)"></search-widget>
                </div>
                }
            </div>
        </div>
        }
    </div>
</section>